import {
    GAI,
    OSM,
    EHM,
    JVM,
    DXA,
    FKT,
    PSB,
    ORP,
    EMI,
    XB,
    IYB,
    TBC,
    AAB,
    ASK,
    TNG,
    ZDM,
    VND,
    IPK,
    NBU,
    GNK,
    GAI2,
    SL,
    TezDoc
} from "@/enums/client";

export let ShipoxRegions = [1, 2]
export let MailPostIndexClients = [GAI,OSM,EHM,JVM,DXA,FKT,PSB,ORP,EMI,XB,IYB,TBC,AAB,ASK,TNG,ZDM,VND,IPK,NBU,GNK,GAI2,SL,TezDoc]
export let MailPostIndexRegions = [1,2]

export const clients = [
    { text: "МАЖБУРИЙ ИЖРО БЮРОСИ (MIB)", value: 0 },
    { text: "ГУББД (ГАИ)", value: 1 },
    { text: "Ташкент тепло-энергия (ТТЕ)", value: 2 },
    { text: "Министерство Юстиции (JVM)", value: 3 },
    { text: "ДАВЛАТ ХИЗМАТЛАР АГЕНТЛИГИ (DXA)", value: 4 },
    { text: "Фактура.уз (FKT)", value: 5 },
    { text: "Единая система гибридной почты (EHM)", value: 6 },
    { text: "Верховный суд РУз (OSM)", value: 7 },
    { text: "ПромСтройБанк (PSB)", value: 8 },
    { text: "Прокуратура РУз (ORP)", value: 9 },
    { text: "Э-Маъмурий иш (EMI)", value: 10 },
    { text: "Народный банк (XB)", value: 11 },
    { text: "Банк Ипак Йули (IYB)", value: 12 },
    { text: "ТБС Банк (TBC)", value: 13 },
    { text: "Азия Аллианс Банк (AAB)", value: 14 },
    { text: "Асака Банк (ASK)", value: 15 },
    { text: "Тенге Банк (TNG)", value: 16 },
    { text: "Зудмолл (ZDM)", value: 17 },
    { text: "Венду (VND)", value: 18 },
    { text: "Э-Кенгаш (EKengash)", value: 19 },
    { text: "Э-ИЖРО (EJR)", value: 21 },
    { text: "Ипотека Банк (IPK)", value: 22 },
    { text: "Микрокредит Банк (MKB)", value: 23 },
    { text: "НБУ Банк (NBU)", value: 24 },
    { text: "ГУББД (ГАИ 2)", value: 25 },
    { text: "УЗИНФОКОМ (INF)", value: 26 },
    { text: "ГНК (GNK)", value: 27 },
    { text: "Давр Банк (DVR)", value: 28 },
    { text: "MEXM (MEXM)", value: 30 },
    { text: "Aloqa Bank (ALQ)", value: 31 },
    { text: "Adliya vazirligi (ADL)", value: 32 },
    { text: "Biznes rivojlantirish bank (BRB)", value: 34 },
    { text: "Kadastr (KAD)", value: 36 },
    { text: "Advokatura (ADV)", value: 38 },
    { text: "Pensiya Jamg'armasi (PJ)", value: 40 },
    { text: "Milliy Gvardiya (MG)", value: 41 },
    { text: "Solutions Lab (SL)", value: 43 },
    { text: "Agro bank (AGR)", value: 44 },
    { text: "TuronBank (TRN)", value: 50 },
    { text: "Apex (APEX)", value: 51 },
    { text: "Markaziy Bank (MBB)", value: 52 },
    { text: "xat.hippo.uz (TD)", value: 53 },
    { text: "GASN (GASN)", value: 54 },
]


export const PRICE_SIMPLE_FOR_HYBRID = 9850
export const PRICE_OVER_PAGE_FOR_HYBRID = 300